export const DEFAULT_REVIEWS_COUNT = 3;
